import { userHasIssueOverviewPermissions } from './accessControl';

/**
 * Returns the children if and only if the current user can see Issue Overview pages.  The feature must be enabled for
 * the organization and the user must have the correct permissions.
 */
export const RequireIssueOverview = <T>({ children, projectId }: { children: T, projectId?: string }): T | null => {
  if (userHasIssueOverviewPermissions(projectId)) {
    return children;
  }

  return null;
};

export default RequireIssueOverview;
